import Scrollbar from 'smooth-scrollbar';
import vars from "../helpers";
const $page = vars.$document.find('.page-inner');
const $toTop = $page.find('.up');
const init = () => {
	if($page.length) {
		let scrollbar =  Scrollbar.init(document.querySelector('.page-inner'),
			{
				speed: 0.75,
				damping: 0.03,
				renderByPixels: true,
				// alwaysShowTracks: true,
				syncCallbacks: true,
			});

		Scrollbar.detachStyle();
		scrollbar.track.xAxis.element.remove();
		$toTop.on('click', () => {
			scrollbar.scrollTo(0, 0, 2000);
		});
	}
};

export default {
	init
};
